<template>
	<div class="keywordData">
		<div class="module-item-style">
			<el-tabs v-model="activeName">
				<el-tab-pane label="关键词统计" name="first"></el-tab-pane>
				<el-tab-pane label="访问明细" name="second"></el-tab-pane>
				<el-tab-pane label="访客明细" name="third"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="module-item-style">
			<div class="module-item-title">
				<div>
					使用说明：
				</div>
				<div class="setting-tips">您在使用关键词统计功能前，需要先到百度推广后台设置关键词跳转链接增加「keyword」和「engine」参数 ，keyword参数是指您要统计的关键词，engine参数是指您要统计的的来源。</div>
			</div>
		</div>
		<keyword-list v-if="activeName == 'first' "></keyword-list>
		<visit-detail v-if="activeName == 'second' "></visit-detail>
		<visitor-detail v-if="activeName == 'third' "></visitor-detail>
	</div>
</template>

<script>
  import keywordList from './keywordList'
  import visitDetail from './visitDetail'
  import visitorDetail from './visitorDetail'
  export default {
    name: 'index',
    components: {
      keywordList,
      visitDetail,
      visitorDetail
    },
    data() {
      return {
        activeName: 'first'
      }
    },
    mounted() {
      const refer = document.referrer
      console.log(123, refer)
    },
    methods: {

    }
  }
</script>

<style lang="scss">
	.keywordData{
		.el-tabs__nav-wrap::after{
			display: none;
		}
		.setting-tips{
			color: #666;
			margin-top: 15px;
			font-weight: normal;
		}
	}
</style>
